"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Updates = function Updates(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "UpdatesTitle UpdatesDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "UpdatesTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "UpdatesDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M27.858 26.653a42.884 42.884 0 0 1-1.262-10.733c0-6.391-4.103-11.031-9.752-11.031-5.493 0-9.75 5.929-9.75 11.031 0 4.813-1.263 10.711-1.276 10.769l-.142.671h6.075a5.12 5.12 0 0 0 10.182 0h6.13l-.205-.707zm-11.014 4.165a4 4 0 0 1-3.968-3.458h7.933a4 4 0 0 1-3.965 3.436v.022zm-9.8-4.61a59.556 59.556 0 0 0 1.16-10.328c0-5.587 4.645-9.92 8.64-9.92 5.085 0 8.64 4.08 8.64 9.92a45.89 45.89 0 0 0 1.12 10.329H7.044zm9.778-22.804a1.267 1.267 0 1 1 .01-2.533 1.267 1.267 0 0 1-.01 2.533z",
    id: "refUpdates-399kZ6KACiV"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refUpdates-399kZ6KACiV"
  }));
};

Updates.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Updates.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Updates;
exports["default"] = _default;